import { useSnackbar } from "notistack";
import { Box, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Bloco, ISbloco } from "../../types/bloco/Bloco";
import { Panel } from "primereact/panel";
import { BlocoForm } from "./BlocoForm";
import { useCreateBloco1Mutation, useCreateBlocoMutation, useGetBlocoQuery, useUpdateBlocoMutation } from "./blocoApiSlice";
import errorFormat from "../../utils/errorFormat";
import { useParams } from "react-router-dom";
import { errorMonitor } from "events";
import { useNavigate } from "react-router-dom";
import configUrls from "../../config/configUrls";



export const BlocoEdit = () => {

    const navigate = useNavigate();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
   
   
    const [updateBloco, status] = useUpdateBlocoMutation();
   
   
    const id = useParams().id || "";
    const { data, isFetching, error } = useGetBlocoQuery(id);
    const [bloco, setBloco] = useState<Bloco>(ISbloco);


    useEffect(() => {
        if (data) {
            setBloco(data);
        }  else if (error) {
            enqueueSnackbar("Registro não encontrado!", { variant: "error" })
        }  else if (isFetching) {
            enqueueSnackbar("Buscando registro...", { variant: "info" })
        }  else {
            enqueueSnackbar("Registro não encontrado!", { variant: "error" })
        }      
    },[data,error,isFetching])



    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        setBloco((prev) => ({
            ...prev,
            [name]: value.toUpperCase(),
        }));

        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        await updateBloco(bloco);
    }

    useEffect(() => {
        if (status.isError) {
            enqueueSnackbar("Registro não alterado!", { variant: "error" })
            const erroReturn: string  = errorFormat(status);          
            enqueueSnackbar(erroReturn, {variant: "error"})
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro alterado com sucesso!", { variant: "success" })
            navigate(configUrls.BLOCO_LIST);   
        }
    }, [status]);


    return (
        <>
            <Paper >

                <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                    Blocos - Edição
                </Typography>



                <BlocoForm
                    data={bloco}
                    // isdisabled={status.isLoading}
                    //isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                />
            </Paper>










        </>







    );










};

/*
 <BlocoTurmaForm
                    blocoTurma={blocoTurmaState}
                    isdisabled={status.isLoading}
                    isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                />
*/